import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationBicycleElectricRacing: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_3628_10426"
        style={{ maskType: 'alpha' }}
        width="356"
        height="229"
        x="0"
        y="-1"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 0h356v227.999H0v-228z"></path>
      </mask>
      <g mask="url(#mask0_3628_10426)">
        <path
          fill={colors.primary[50]}
          d="M337 161c0 88.365-71.634 160-160 160S17 249.365 17 161C17 72.634 88.634 1 177 1s160 71.634 160 160z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 225.999A2 2 0 0122 224h310a2 2 0 110 3.999H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
        <circle
          r="37.5"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 239.5 186.5)"
        ></circle>
        <circle
          r="29.5"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 239.5 186.5)"
        ></circle>
        <circle
          r="37.5"
          fill={colors.primary[100]}
          stroke={colors.primary[500]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 116.5 186.5)"
        ></circle>
        <circle
          r="29.5"
          fill="#fff"
          stroke={colors.primary[500]}
          strokeWidth="4"
          transform="matrix(-1 0 0 1 116.5 186.5)"
        ></circle>
        <path
          stroke={colors.primary[500]}
          strokeLinecap="round"
          strokeWidth="4"
          d="M240 188l-55.5 7M184.5 195l-43-56.5M116.5 188l32-64.5M208.5 136.5L145 132M184.5 195l36-86M240 188l-36-39.5M148.5 123.5h-26.581c-.52 0-.954.4-.991.918-.44 6.231.382 9.679 6.572 13.582"
        ></path>
        <rect
          width="36"
          height="8"
          fill={colors.primary[500]}
          rx="4"
          transform="matrix(-1 0 0 1 237 105)"
        ></rect>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M147.292 34.147a1.492 1.492 0 011.999.676l3.899 7.884 3.241-3.29a1.494 1.494 0 012.385.353l4.81 9.158a1.491 1.491 0 11-2.642 1.388l-3.86-7.349-3.279 3.328a1.492 1.492 0 01-2.4-.385l-4.829-9.764a1.493 1.493 0 01.676-2zM182.21 18.644c.778.27 1.191 1.12.921 1.899l-2.881 8.31h4.619a1.493 1.493 0 011.421 1.947l-3.148 9.853a1.491 1.491 0 11-2.842-.908l2.525-7.907h-4.671a1.492 1.492 0 01-1.41-1.981l3.567-10.292a1.493 1.493 0 011.899-.92zM234.375 55.974a1.492 1.492 0 01-1.762 1.162l-8.615-1.77.604 4.58a1.493 1.493 0 01-1.744 1.663l-10.181-1.832a1.492 1.492 0 11.529-2.937l8.17 1.47-.611-4.632a1.49 1.49 0 011.779-1.657l10.67 2.191a1.492 1.492 0 011.161 1.762zM221.795 83.83a1.492 1.492 0 01-2.094.258l-6.935-5.41-1.492 4.37a1.491 1.491 0 01-2.301.717l-8.308-6.162a1.492 1.492 0 111.778-2.397l6.667 4.944 1.509-4.42a1.494 1.494 0 012.33-.695l8.588 6.7c.649.508.765 1.445.258 2.095zM174.104 68.749a1.492 1.492 0 01-.251 2.095l-10.446 8.207a1.52 1.52 0 01-.15.104c-2.479 1.499-5.324 4.309-6.136 7.808-.771 3.326.193 7.769 6.322 12.9a1.492 1.492 0 11-1.916 2.288c-6.703-5.612-8.413-11.118-7.313-15.862 1.05-4.53 4.566-7.892 7.419-9.64l10.376-8.152a1.492 1.492 0 012.095.252z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M196.158 45.304c.484.667.337 1.6-.33 2.085l-9.49 6.895a1.492 1.492 0 11-1.754-2.415l9.49-6.895a1.492 1.492 0 012.084.33zM203.619 55.004c.484.666.336 1.6-.33 2.084l-9.49 6.895a1.493 1.493 0 01-1.754-2.415l9.489-6.894a1.493 1.493 0 012.085.33z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M188.448 74.103c-.001.001-.002.003-.001.004v.003a12.313 12.313 0 01-17.194-2.725 12.306 12.306 0 012.719-17.193v-.003l.001-.003 6.505-4.727a1.492 1.492 0 012.084.33l12.718 17.505c.485.667.337 1.6-.33 2.085l-6.502 4.724z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M179.601 48.252a2.985 2.985 0 014.169.66l12.718 17.506a2.984 2.984 0 01-.661 4.168l-6.41 4.658c-.03.025-.061.05-.094.073a13.801 13.801 0 01-21.744-13.327 13.804 13.804 0 015.418-8.933c.032-.028.065-.053.099-.078l6.505-4.727zm-4.659 7.074c-.03.026-.06.05-.092.073a10.816 10.816 0 004.67 19.435 10.819 10.819 0 007.963-1.869c.028-.024.057-.047.088-.069l6.502-4.724-12.718-17.505-6.413 4.66z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

export default IllustrationBicycleElectricRacing;
